import axios from 'src/utils/terotechDataservice';

function get(){
    const options = {
        headers: {'Content-Type': 'application/json'}
      };
    return axios.get('/user/settings', options);
}

function post(data){
    const options = {
      headers: {'Content-Type': 'application/json'}
    };
    return axios.post('/user/settings',data,options);
  }

  export {
    get,
    post

  }